module.exports = __webpack_public_path__ + "img/icon_no_loyalty.b8548438.svg";